import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";

export const LineaSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);
  const [linea, setLinea] = useState([]);

  const capitalizeWords = (text) => {
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  useEffect(() => {
    request
      .get("ListadoFacturacionMaquinaria/Lineas")
      .then((result) => {
        setLinea(result);
        const lineasOptions = result.map((linea) => ({
          linea: capitalizeWords(linea.descripcion), 
          value: linea.idlinea, 
        }));
        setState(lineasOptions);
      })
      .catch((error) => {
        JSON.stringify("PERMISOS", "ERROR....", "error");
      });
  }, []);

  return (
    <select
      className="select-lineas"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="-1">Seleccionar... </option>
      <option value="0">Consolidado</option>
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};